module.exports = __webpack_public_path__ + "img/mosque.451633ff.png";